<template>
  <iframe v-if="!isAppClassic()" src="https://numer.ai/_auth/frame"></iframe>
</template>

<script>
// See authframe/index.html for where this iframe code lives, but essentially
// the page w/ the iframe will `postMessage` with the authToken and username.
// If they exist, absorb them into the current app by calling `saveAuthInfo`.
import { mapGetters } from 'vuex'
import { isAppClassic } from '@/lib/utils'
export default {
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  created() {
    if (localStorage.getItem('invalidLocalAuthInfo') == 'true') {
      return
    }

    const handleIframeMessage = event => {
      if (event.origin !== 'https://numer.ai') {
        return
      }

      const data = event.data
      if (!data || !data.token) {
        return
      }

      this.$store.dispatch('saveAuthInfo', data)
    }

    if (!isAppClassic() && !this.isLoggedIn) {
      window.addEventListener('message', handleIframeMessage, false)
    }
  },
  methods: {
    isAppClassic,
  },
}
</script>

<style scoped lang="scss">
iframe {
  height: 1px;
  width: 1px;
  position: absolute;
  left: -50000px;
}
</style>
